import * as yup from "yup";

import {
  referenceMetadata,
  REFERENCES_METADATA,
} from "../../../ui-v2/References/constants";
import {
  MAX_DENSITY,
  MAX_REFERENCE_SIMILARITY,
  MIN_DENSITY,
  MIN_REFERENCE_SIMILARITY,
} from "../../constants";
import { validationSchema as validationSchemaForm2D } from "../2D/validationSchema";
import {
  FORM_FIELDS_CANVAS_CREATE,
  FORM_FIELDS_CANVAS_PROMPT_EDIT,
} from "./constants";
import { FormTypeCanvasCreate2D, FormTypeCanvasPromptEdit } from "./types";

export const validationSchemaCanvasCreate2D = validationSchemaForm2D.shape({
  [FORM_FIELDS_CANVAS_CREATE.PROMPT_TEXT]: yup.string(),
  [FORM_FIELDS_CANVAS_CREATE.REFILL]: yup.boolean().required(),
  [FORM_FIELDS_CANVAS_CREATE.CANVAS_SELECTION]: yup.object().shape({
    type: yup.string().when("image.src", {
      is: (src: string | null) => !!src,
      then: (schema) =>
        schema.required().oneOf(
          Object.keys(REFERENCES_METADATA).filter(
            (key) => referenceMetadata(key)?.isLocalized ?? false,
          ),
          "Selected Guidance Type is not valid.",
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
    image: yup
      .object()
      .shape({
        src: yup.string(),
      })
      .nullable(),
    similarity: yup
      .number()
      .typeError("Invalid value.")
      .when("image.src", {
        is: (src: string | null) => !!src,
        then: (schema) =>
          schema
            .required()
            .min(
              MIN_REFERENCE_SIMILARITY,
              `Similarity must be at least ${MIN_REFERENCE_SIMILARITY}`,
            )
            .max(
              MAX_REFERENCE_SIMILARITY,
              `Similarity must be at most ${MAX_REFERENCE_SIMILARITY}`,
            ),
        otherwise: (schema) => schema.notRequired(),
      }),
    density: yup
      .number()
      .typeError("Invalid value.")
      .when("image.src", {
        is: (src: string | null) => !!src,
        then: (schema) =>
          schema
            .required()
            .min(MIN_DENSITY, `Density must be at least ${MIN_DENSITY}`)
            .max(MAX_DENSITY, `Density must be at most ${MAX_DENSITY}`),
        otherwise: (schema) => schema.notRequired(),
      }),
  }),
}) as yup.ObjectSchema<FormTypeCanvasCreate2D>;

export const validationSchemaCanvasPromptEdit = yup.object().shape({
  [FORM_FIELDS_CANVAS_PROMPT_EDIT.PROMPT_TEXT]: yup
    .string()
    .required("Prompt text for editing is required."),
  [FORM_FIELDS_CANVAS_PROMPT_EDIT.CANVAS_SELECTION]: yup.object().shape({
    type: yup.string().when("image.src", {
      is: (src: string | null) => !!src,
      then: (schema) =>
        schema.required().oneOf(
          Object.keys(REFERENCES_METADATA).filter(
            (key) => referenceMetadata(key)?.isLocalized ?? false,
          ),
          "Selected Guidance Type is not valid.",
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
    image: yup
      .object()
      .shape({
        src: yup.string(),
      })
      .nullable(),
    density: yup
      .number()
      .typeError("Invalid value.")
      .when("image.src", {
        is: (src: string | null) => !!src,
        then: (schema) =>
          schema
            .required()
            .min(MIN_DENSITY, `Density must be at least ${MIN_DENSITY}`)
            .max(MAX_DENSITY, `Density must be at most ${MAX_DENSITY}`),
        otherwise: (schema) => schema.notRequired(),
      }),
  }),
}) as yup.ObjectSchema<FormTypeCanvasPromptEdit>;
